import { render, staticRenderFns } from "./serviceBBS.vue?vue&type=template&id=26f8aa33"
import script from "./serviceBBS.vue?vue&type=script&lang=js"
export * from "./serviceBBS.vue?vue&type=script&lang=js"
import style0 from "./serviceBBS.vue?vue&type=style&index=0&id=26f8aa33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports